import { createContext, useContext } from 'react';

/**
 * The set-as-banner action a tile offers to the admin context menu wrapping
 * it. The action always targets the slide currently visible in the tile's
 * carousel, so tiles re-register it on every slide change.
 */
export interface TileBannerMenuAction {
    /** True when the visible slide is already the project banner. */
    isCurrentBanner: boolean;
    /** Set the visible slide as the project banner. */
    setCurrentAsBanner: () => void;
}

/**
 * Lets a tile publish its set-as-banner action up to the AdminContextMenu
 * that wraps it — the menu lives above the tile in the tree, so it cannot see
 * the tile's carousel state directly. AdminTile provides the registry;
 * ProjectTile registers whenever the visible slide or banner selection
 * changes and clears the registration when the action is unavailable.
 */
export const TileBannerMenuContext = createContext<{
    register: (action: TileBannerMenuAction | null) => void;
} | null>(null);

export const useTileBannerMenuRegistry = () =>
    useContext(TileBannerMenuContext);
